export interface BannerProps {
    header: string,
    body: string,
    button: string,
    link: string,
    theme?: string | undefined
}

export default function Banner(props: BannerProps) {
    return <div className={'banner bannertheme-' + props.theme}>
        <div className="banner-container">
            <div className="banner-text">
                <div className="heading">{props.header}</div>
                <p>{props.body}</p>
            </div>
            { props.button &&
                <a href={props.link} target="_blank" rel="noreferrer"><button>{props.button}</button></a>
            }
        </div>
    </div>;
}
